import React from 'react';
import { ScrollView, View } from 'react-native';
import { Button } from 'react-native-elements';
import useMediumScreen from 'hooks/useMediumScreen';
import CommerceListProps from 'types/components/CommerceListProps';
import OrderContext from 'contexts/OrderContext';
import AppContext from 'contexts/AppContext';
import CommerceItem from 'components/CommerceItem';
import CommerceAction from './CommerceAction';
import { styles } from 'styles/components/commerceList';
import UserRoleType from 'types/enums/UserRoleType';
import { useTranslation } from 'react-i18next';

export default ({ commerces, totalBillings, navigation }: CommerceListProps): JSX.Element => {
  const mediumScreen = useMediumScreen();
  const { setCurrentCommerce, currentCommerce, currentVenue } = React.useContext(OrderContext);
  const { authData } = React.useContext(AppContext);

  const [showMenuModalByCommerce, setShowMenuModalCommerce] = React.useState<string>('');
  const scrollViewContainerRef = React.useRef<ScrollView>(null);

  const { t } = useTranslation();

  const showChargeBalanceBtn = (): boolean => {
    if (!authData?.user.role) return false;
    if (!currentVenue?.paymentConfig?.balanceEnabled) return false;

    const enabledRoles = [UserRoleType.VenueEditor, UserRoleType.FranchiseEditor];
    if (!enabledRoles.includes(authData.user.role)) return false;

    return true;
  };

  const renderMediumScreen = (): JSX.Element => {
    return (
      <>
        <ScrollView
          keyboardShouldPersistTaps="handled"
          scrollEnabled={true}
          style={[styles.cardColumnSmall]}
          ref={scrollViewContainerRef}
        >
          {commerces.map((commerce) => (
            <CommerceItem
              key={commerce.id}
              commerce={commerce}
              onPress={() => {
                setCurrentCommerce(commerce);
              }}
              totalBilling={totalBillings[commerce.id]}
              isMediumScreen={mediumScreen}
              navigation={navigation}
              setShowMenuModalByCommerce={setShowMenuModalCommerce}
              containerRef={scrollViewContainerRef}
            />
          ))}
          {currentCommerce && showMenuModalByCommerce === currentCommerce.id && (
            <CommerceAction
              navigation={navigation}
              commerce={currentCommerce}
              showMenuModalByCommerce={showMenuModalByCommerce}
              setShowMenuModalByCommerce={setShowMenuModalCommerce}
            />
          )}
        </ScrollView>
      </>
    );
  };

  const renderLargeScreen = (): JSX.Element => {
    return (
      <View style={styles.cardsContainerLarge}>
        {commerces.map((commerce, index) => (
          <CommerceItem
            key={index}
            commerce={commerce}
            onPress={() => {
              setCurrentCommerce(commerce);
            }}
            totalBilling={totalBillings[commerce.id]}
            isMediumScreen={mediumScreen}
            navigation={navigation}
            setShowMenuModalByCommerce={setShowMenuModalCommerce}
          />
        ))}
      </View>
    );
  };
  return (
    <View style={styles.listContainer}>
      {showChargeBalanceBtn() && (
        <Button
          onPress={() => navigation.navigate('AccountBalanceScreen')}
          title={t('reload-balance')}
          type="solid"
          buttonStyle={styles.buttonRecharge}
          titleStyle={mediumScreen ? styles.buttonRechargeTitleLarge : styles.buttonRechargeTitleSmall}
          containerStyle={mediumScreen ? styles.buttonContainerLarge : styles.buttonContainerSmall}
        />
      )}
      {mediumScreen ? renderLargeScreen() : renderMediumScreen()}
    </View>
  );
};
